import * as React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Footer from "./Components/Footer/Footer";
import Navbar from "./Components/Navbar/Navbar";
import Search from "./Components/Search/Search";
import Homepage from "./Pages/Sections/Homepage";
import SkillPage from "./Pages/Sections/SkillPage";
import ServicePage from "./Pages/Sections/ServicePage";
import Fullstack from "./Components/Our-services/Fullstack";
import Appdeve from "./Components/Our-services/Appdeve";
import Ui from "./Components/Our-services/Ui";
import Frontend from "./Components/Our-services/Full-stack/Frontend";
import Contact from "./Components/Contact";
import About from "./Pages/About";
import Gotop from "./Components/Gotop/Gotop";
import Whatsapp from "./Components/Whatsapp/Whatsapp";
import FAQPage from "./Pages/FAQPage";

const App = () => {
  return (
    <>
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/about" element={<About />} />
          <Route path="/search" element={<Search />} />
          <Route path="/our-service" element={<ServicePage />} />
          <Route path="/skills" element={<SkillPage />} />

          {/* service */}
          <Route path="/Fullstack-web-development" element={<Fullstack />} />
          <Route path="/App-development" element={<Appdeve />} />
          <Route path="/product-design" element={<Ui />} />
          <Route path="/frontend" element={<Frontend />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/contact" element={<Contact />} />

        </Routes>
        <Gotop />
        <Whatsapp />
        <Footer />
      </Router>
    </>
  );
};

export default App;
